module.exports = __webpack_public_path__ + "media/new/outline-96-80817c09.png";